export enum Put {
  ResetPassword = 'resetPassword',
  UpdatePassword = 'updatePassword',
}
